module.exports = __webpack_public_path__ + "img/album06_05.abb30836.jpg";